const menuItemsMobile = [
  {
    text: "Home",
    internalLink: "/home",
    to: "home/",
    available: true,
  },
  {
    text: "Qué es Photio",
    internalLink: "/whatis",
    to: "/whatis",
    available: true,
  },
  {
    text: "Quiénes somos",
    internalLink: "/about",
    to: "/about",
    available: true,
  },
  {
    text: "Proyectos",
    internalLink: "/proyects",
    to: "/proyects",
    available: true,
  },
  {
    text: "NanoFactoría",
    internalLink: "/applications",
    to: "/applications",
    available: true,
  },
  {
    text: "Contacto",
    internalLink: "/contact",
    to: "/contact",
    available: true,
  },
  {
    text: "Preguntas Frecuentes",
    internalLink: "/questions",
    to: "/questions",
    available: false,
  },
  {
    text: "CHANGE TO ENGLISH",
    internalLink: "idioma",
    available: false,
  },
];

const textContent = {
  menu: "MENU",
  close: "CERRAR",
};

export const menuMobileContent = {
  menuItemsMobile,
  textContent,
};
